import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import 'bootstrap/dist/css/bootstrap.min.css';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'Legal',
  setup(__props) {

const { t } = useI18n();
const store = useStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container mt", { 'dark-mode': _unref(store).state.dark }])
  }, [
    _createElementVNode("h2", {
      style: {"font-family":"'Bebas Neue', cursive","font-size":"60px"},
      class: _normalizeClass([ _ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar' ? 'text-right' : 'text-left' ])
    }, _toDisplayString(_unref(t)('legals.header')), 3),
    _createElementVNode("h4", {
      class: _normalizeClass(["overflow-auto", [ _ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar' ? 'text-right' : 'text-left' ]])
    }, _toDisplayString(_unref(t)('legals.update')), 3),
    _createElementVNode("h3", {
      style: {"font-family":"'Bebas Neue', cursive","font-size":"40px"},
      class: _normalizeClass([ _ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar' ? 'text-right' : 'text-left' ])
    }, _toDisplayString(_unref(t)('legals.secondHeader')), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["overflow-auto", [ _ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar' ? 'text-right' : 'text-left' ]]),
      style: {"font-size":"20px","font-family":"'Roboto', sans-serif"}
    }, [
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('legals.t1')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('legals.p1')), 1),
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('legals.t2')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('legals.p2')), 1),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, _toDisplayString(_unref(t)('legals.bp1')), 1),
        _createElementVNode("li", null, _toDisplayString(_unref(t)('legals.bp2')), 1),
        _createElementVNode("li", null, _toDisplayString(_unref(t)('legals.bp3')), 1),
        _createElementVNode("li", null, _toDisplayString(_unref(t)('legals.bp4')), 1),
        _createElementVNode("li", null, _toDisplayString(_unref(t)('legals.bp5')), 1)
      ]),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('legals.p2Continuation')), 1),
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('legals.t3')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('legals.p3')), 1),
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('legals.t4')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('legals.p4')), 1),
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('legals.t5')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('legals.p5')), 1),
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('legals.t6')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('legals.p6')), 1),
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('legals.t7')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('legals.p7')), 1),
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('legals.t8')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('legals.p8')), 1),
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('legals.t9')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('legals.p9')), 1)
    ], 2),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1))
  ], 2))
}
}

})